"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhithModalContext = exports.ContainerContext = exports.ProviderContext = void 0;
const react_1 = require("react");
exports.ProviderContext = (0, react_1.createContext)({
    push: () => { },
    count: () => 0,
    modals: null
});
exports.ContainerContext = (0, react_1.createContext)({
    hide: () => { },
    setFooter: (element) => { },
    initPosition: { current: undefined },
    footer: {}
});
exports.WhithModalContext = (0, react_1.createContext)({
    setConfig: () => { },
    state: {},
    footerRef: null,
    showPopup: () => { },
    show: () => { },
    hide: () => { }
});
